import { SxProps } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import SwitchBase, { type SwitchProps } from '@mui/material/Switch';
import React from 'react';

function Switch({
  sx = {},
  checked,
  label,
  disabled = false,
  color = 'success',
  onClick,
  inputRef = undefined,
  size = 'small',
}: {
  sx?: SxProps;
  checked: boolean;
  color?: SwitchProps['color'];
  label: React.ReactNode;
  disabled?: boolean;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  inputRef?: React.Ref<unknown>;
  size?: 'small' | 'medium';
}) {
  const control = (
    <SwitchBase
      checked={checked}
      disabled={disabled}
      value={checked}
      onClick={onClick}
      color={color}
      size={size}
    />
  );
  return <FormControlLabel control={control} sx={sx} label={label} ref={inputRef} />;
}

export default Switch;
